const URLASSOLUTO = window.URLASSOLUTO;
const URLASSOLUTOISTITUZIONALE = window.URLASSOLUTOISTITUZIONALE;
delete window.URLASSOLUTO;
delete window.URLASSOLUTOISTITUZIONALE;

export { URLASSOLUTO, URLASSOLUTOISTITUZIONALE };
